import assertNever from 'assert-never';

import { RemoveDeviceFromGatewayStatus, RemoveDevicesFromGatewayResult } from '@shure/cloud/shared/models/devices';

import { CloudGatewayRemoveDeviceStatus, RemoveDevicesFromGatewayOpResult } from '../graphql/generated/cloud-sys-api';

export function mapRemoveDevicesFromGatewayResultFromSysApi(
	result: RemoveDevicesFromGatewayOpResult
): RemoveDevicesFromGatewayResult {
	return {
		devices: result.removeDevicesFromCloudGateway.map((deviceResult) => ({
			hardwareId: deviceResult.hardwareId,
			status: mapCloudGatewayRemoveDeviceStatusFromSysApi(deviceResult.status)
		}))
	};
}

function mapCloudGatewayRemoveDeviceStatusFromSysApi(
	status: CloudGatewayRemoveDeviceStatus
): RemoveDeviceFromGatewayStatus {
	switch (status) {
		case CloudGatewayRemoveDeviceStatus.CloudGatewayNotFound:
			return RemoveDeviceFromGatewayStatus.GatewayNotFound;
		case CloudGatewayRemoveDeviceStatus.DeviceNotFound:
			return RemoveDeviceFromGatewayStatus.DeviceNotFound;
		case CloudGatewayRemoveDeviceStatus.Failure:
			return RemoveDeviceFromGatewayStatus.GenericFailure;
		case CloudGatewayRemoveDeviceStatus.Success:
			return RemoveDeviceFromGatewayStatus.Success;
		case CloudGatewayRemoveDeviceStatus.DeviceUpdating:
			return RemoveDeviceFromGatewayStatus.DeviceUpdating;
		default:
			assertNever(status);
	}
}
